/**
 * Actions related to stylesheetss
 */

import {
    getSpacingStylesheet,
    getSpacingStyleRules,
} from "../selectors/template";

/**
 * Insert a spacing rule with the rule text into the stylesheet and remove the last rule
 * @param rule
 * @returns {*}
 */
export const insertSpacingRule = state => {
    const rules = getSpacingStyleRules(state);
    const existingStyleSheet = getSpacingStylesheet(state);
    const newStyleSheet = document.createElement("style");

    if (existingStyleSheet) {
        console.log(
            "Deleting sheet",
            [...existingStyleSheet.sheet.rules].reduce(
                (str = "", rule) => str + rule.cssText,
                0
            )
        );
        document.head.removeChild(existingStyleSheet);
    }
    document.head.appendChild(newStyleSheet);

    if (rules.length) {
        rules.forEach(ruleText => newStyleSheet.sheet.insertRule(ruleText));
    }
    console.log(
        "Adding sheet",
        [...newStyleSheet.sheet.rules].reduce(
            (str = "", rule) => str + rule.cssText,
            0
        )
    );

    return {
        type: "styles/INSERT_SPACING_RULES",
        payload: {
            spacingStylesheet: newStyleSheet,
        },
    };
};
